/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.card.associated.objects.rpc.AssociatedObjectsGatewayRpc
 */

export const CommercePaymentAssociatedObjectTypename = 'com.hubspot.card.associated.objects.models.responses.CommercePaymentAssociatedObject';
/**
 *  Interface for Commerce Payment associated object items.
 *  Contains specialized fields for Commerce Payment object type (0-101).
 */

export const CompanyAssociatedObjectTypename = 'com.hubspot.card.associated.objects.models.responses.CompanyAssociatedObject';
/**
 *  Interface for Company associated object items.
 *  Contains specialized fields for Company object type (0-2).
 */

export const ContactAssociatedObjectTypename = 'com.hubspot.card.associated.objects.models.responses.ContactAssociatedObject';
/**
 *  Interface for Contact associated object items.
 *  Contains specialized fields for Contact object type (0-1).
 */

export const DealAssociatedObjectTypename = 'com.hubspot.card.associated.objects.models.responses.DealAssociatedObject';
/**
 *  Interface for Deal associated object items.
 *  Contains specialized fields for Deal object type (0-3).
 */

export const GenericAssociatedObjectTypename = 'com.hubspot.card.associated.objects.models.responses.GenericAssociatedObject';
export const MeetingAssociatedObjectTypename = 'com.hubspot.card.associated.objects.models.responses.MeetingAssociatedObject';
/**
 *  Interface for Meeting associated object items.
 *  Contains specialized fields for Meeting object type (0-47).
 */

export const TicketAssociatedObjectTypename = 'com.hubspot.card.associated.objects.models.responses.TicketAssociatedObject';
/**
 *  Interface for Ticket associated object items.
 *  Contains specialized fields for Ticket object type (0-5).
 */

/**
 *  Repo-specific implementation of the PropertyDefinition immutable since the existing type isn't annotated with @ChirpMessage
 */

/**
 *  Represents labels associated with an object.
 */

export let ComHubspotCardAssociatedObjectsModelsResponsesUtil;
(function (_ComHubspotCardAssociatedObjectsModelsResponsesUtil) {})(ComHubspotCardAssociatedObjectsModelsResponsesUtil || (ComHubspotCardAssociatedObjectsModelsResponsesUtil = {}));
export let ComHubspotContactsDataContactsProtos;
(function (_ComHubspotContactsDataContactsProtos) {})(ComHubspotContactsDataContactsProtos || (ComHubspotContactsDataContactsProtos = {}));
export const getAssociatedObjectsPagedRpc = {
  serviceName: 'com.hubspot.card.associated.objects.rpc.AssociatedObjectsGatewayRpc',
  rpcName: 'getAssociatedObjectsPaged',
  auth: 'app',
  fingerprint: 'WEX9mrxkS2W4ori3Gf41ySTa0pQspj9p',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};